import { styled } from "@mui/material";
import { tokens } from "@styles/tokens";

const LEGAL = {
  privacy: "https://skuey.com/privacy-policy",
  terms: "https://skuey.com/terms-of-service",
};

/** Copyright + legal links shown beneath the auth form. */
export function AuthFooter() {
  const year = new Date().getFullYear();
  return (
    <Root>
      <span>© {year} Skuey. All rights reserved.</span>
      <Links>
        <Link href={LEGAL.privacy} target="_blank" rel="noreferrer">
          Privacy Policy
        </Link>
        <span aria-hidden>·</span>
        <Link href={LEGAL.terms} target="_blank" rel="noreferrer">
          Terms of Service
        </Link>
      </Links>
    </Root>
  );
}

const Root = styled("footer")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: tokens.space(1),
  textAlign: "center",
  fontFamily: tokens.font.family,
  fontSize: tokens.font.size.micro[0],
  lineHeight: `${tokens.font.size.micro[1]}px`,
  color: theme.skuey.muted,
}));

const Links = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: tokens.space(1.5),
  color: theme.skuey.subtle,
}));

const Link = styled("a")(({ theme }) => ({
  color: theme.skuey.muted,
  textDecoration: "none",
  "&:hover": { color: theme.skuey.brand[600] },
}));
